import { buildConnection } from '$app/arrp-hub-connection-builder'
import apiConnection from '$app/plugins/api-connection'
import defaultPagingInfo from '$app/default-paging-info'

const connection = buildConnection('ProgramYear');

// STATE
const state = {
  items: [],
  locks: [],
  nextId: 0,
  pagingInfo: defaultPagingInfo(),
  totalItems: 0
}

// MUTATIONS
const mutations = {
  setItems(state, items) {
    state.items = items;
    state.totalItems = items.length;
  },
  addItem() {
  },
  updateItem() {
  },
  deleteItem() {
  },
  setLocks(state, locks) {
    state.locks = locks;
  }
}

// ACTIONS
const actions = ({
  async connect({ commit, dispatch }) {
    connection.onLocksUpdated((locks) => commit('setLocks', locks));
    connection.onEntitiesUpdated(() => dispatch('getPagedData'));
    await connection.connect();
  },
  async disconnect() {
    await connection.disconnect();
  },
  async itemAdded({ dispatch, getters }, item) {
    const promise = new Promise((resolve, reject) => {
      item.programYearDesc = getters.getCurrentYearDesc;
      item.programYearValue = getters.getCurrentYearValue;
      apiConnection.post('api/arrp/CreateProgramYear', item)
        .then((response) => {
          if (response && response.data && response.data.programYearId) {
            resolve(response.data);
            dispatch('getPagedData');
          } else {
            reject(response);
          }
        })
        .catch((error) => { reject(error) });
    });
    return promise
  },
  itemEdited({ dispatch }, item) {
    apiConnection.put('api/arrp/UpdateProgramYear', item).then(() => dispatch('getPagedData'))
  },
  lockItem({ commit }, item) {
    connection.lockById(item.programYearId);
  },
  unlockItem({ commit }, item) {
    connection.unlockById(item.programYearId);
  },
  deleteItem() {
  },
  getPagedData({ commit }, page) {
    apiConnection.get('api/arrp/GetProgramYears')
      .then((response) => {
        const items = response.data.map((item, idx) => ({ ...item, locked: !!idx }));
        commit('setItems', items)
      });
  }
})

// GETTERS
const getters = {
  getCurrentYear(state, localGetters, baseState) {
    let startYear = Number.parseInt(baseState.configs.maxYear);
    if (state.items && state.items.length) {
      startYear = 1 + Number.parseInt(state.items[0].programYearDesc.substring(0, 4));
    }
    return startYear
  },
  getCurrentYearDesc(state, getters) {
    return `${getters.getCurrentYear}-${getters.getCurrentYear - 1999}`;
  },
  getCurrentYearValue(state, getters) {
    return `${getters.getCurrentYear - 2000}${getters.getCurrentYear - 1999}`;
  },
  currentPage: state => state.items.map(item => ({ ...item, locked: state.locks.includes(item.programYearId) || item.locked }))
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
